import { render, staticRenderFns } from "./MasterJenisBarang.vue?vue&type=template&id=2ce12e04&"
import script from "./MasterJenisBarang.vue?vue&type=script&lang=js&"
export * from "./MasterJenisBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports